import type { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox';

/**
 * Checkbox component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/checkbox/index.ts
 *
 * Component documentation:
 * https://primeng.org/checkbox
 */
export const checkboxComponentTokens: Partial<CheckboxDesignTokens> = {
  root: {
    width: '1.5rem',
    height: '1.5rem',
  },
};


